<div
	class="bg-off-white lg:p-[46px] p-[26px] max-w-[981px] m-auto custom-shadow rounded-12px"
>
	<div class="text-center mb-[36px]">
		<p class="text-medium-gray text-[12px]">
			{{ 'OFFERS.PROMO_CODE' | translate }}
		</p>
		<p class="text-[#4E4B66] font-semibold leading-[26px] text-[24px]">
			{{ 'OFFERS.PROMO_CODE' | translate }} {{ '' }} {{ '['
			}}{{
				translate.currentLang == 'ar'
					? offerData?.name?.ar
					: offerData?.name?.en
			}}{{ ']' }}
		</p>
	</div>
	<div class="flex flex-col">
		<!-- activation status and basic info section -->
		<app-add-promo-code-basic-info
			[offerData]="offerData"
		></app-add-promo-code-basic-info>
		<!-- country & price  -->
		<app-add-promo-code-country-price
			[offerData]="offerData"
		></app-add-promo-code-country-price>
	</div>
</div>
